import React from 'react';

export default function CardItinerario({ num, title, lugar }) {
    return (
      <>
        <div className="bg-primary-100 mt-6 border-primary-800 border-2 rounded-lg w-full h-[60px] flex justify-left items-center gap-1">
            <div className="text-primary-50 bg-primary-800 text-[40px] font-bold rounded-l-lg px-2">{num}</div>
            <div>
                <div className="text-primary-900 text-[18px] font-bold">{title}</div>
                <div className="text-primary-800 text-[12px] font-light">{lugar}</div>
            </div>
        </div>
      </>
    );
  }



